function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import classnames from 'classnames';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import React, { forwardRef, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { usePreviousDistinct } from 'react-use';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CART_TABLE } from '../../constants/table';
import { RESET_FORM_DELAY } from '../../pages/constants';
import text, { formatSqmArea } from '../../text';
import { selectionNameSchema } from '../../validation/job';
import Icon from '../icon/Icon';
import { PRODUCT_DATA } from '../mapView/constants';
import { MapViewContext } from '../mapView/mapViewContext';
import Cell from '../table/Cell';
var COLUMN = CART_TABLE.COLUMN;
var SQM_IN_SQKM = 1e6;
var SimpleDataRow = /*#__PURE__*/ forwardRef(function(param, ref) {
    var data = param.data, coverage = param.coverage, index = param.index, useMeatballDropdown = param.useMeatballDropdown, _param_showClearWhenShapeSelected = param.showClearWhenShapeSelected, showClearWhenShapeSelected = _param_showClearWhenShapeSelected === void 0 ? true : _param_showClearWhenShapeSelected, handleSetOpenedShapeMenu = param.handleSetOpenedShapeMenu;
    var _state_hoveredData, _state_hoveredData1;
    var _useContext = useContext(MapViewContext), state = _useContext.state, actions = _useContext.actions;
    var previousName = usePreviousDistinct(data.name);
    var _useState = _sliced_to_array(useState(false), 2), isSuccess = _useState[0], setIsSuccess = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), hasInitialValueLoaded = _useState1[0], seHasInitialValueLoaded = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), isNameFocused = _useState2[0], setIsNameFocused = _useState2[1];
    var _data_name;
    var dataName = (_data_name = data.name) !== null && _data_name !== void 0 ? _data_name : "Shape ".concat(index + 1);
    var isQuotingJob = useSelector(function(reduxState) {
        return {
            isQuotingJob: reduxState.jobsReducer.isQuotingJob
        };
    }).isQuotingJob;
    var layerMeatballDropdown = useRef();
    var shapeMenuIsOpened = useMemo(function() {
        return state.openedShapeMenu.data && state.shapeMenuModalRef;
    }, [
        state.openedShapeMenu.data,
        state.shapeMenuModalRef
    ]);
    var debounceSetIsSuccess = useCallback(debounce(function(value) {
        return setIsSuccess(value);
    }, RESET_FORM_DELAY));
    var shapeArea = useMemo(function() {
        if (coverage === null || coverage === void 0 ? void 0 : coverage.area_in_sqm) {
            if (coverage.area_in_sqm > SQM_IN_SQKM) {
                return "".concat((coverage.area_in_sqm / SQM_IN_SQKM).toLocaleString(undefined, {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1
                }), " km\xb2");
            }
            return formatSqmArea(coverage.area_in_sqm);
        }
        return '';
    }, [
        coverage
    ]);
    var handleClick = function(event) {
        var _layerMeatballDropdown_current;
        if (((_layerMeatballDropdown_current = layerMeatballDropdown.current) === null || _layerMeatballDropdown_current === void 0 ? void 0 : _layerMeatballDropdown_current.contains(event.target)) || shapeMenuIsOpened) {
            return;
        }
        actions.makeSelectionActive(data, showClearWhenShapeSelected);
    };
    var selectedColour = function() {
        var _PRODUCT_DATA_entities_data_category_name;
        return (_PRODUCT_DATA_entities_data_category_name = PRODUCT_DATA.entities[data.category_name]) === null || _PRODUCT_DATA_entities_data_category_name === void 0 ? void 0 : _PRODUCT_DATA_entities_data_category_name.display_color;
    }();
    useEffect(function() {
        seHasInitialValueLoaded(true);
    }, []);
    useEffect(function() {
        if (previousName && data.name !== previousName && hasInitialValueLoaded) {
            setIsSuccess(true);
        }
        debounceSetIsSuccess(false);
    }, [
        previousName,
        data.name,
        hasInitialValueLoaded,
        debounceSetIsSuccess
    ]);
    return /*#__PURE__*/ React.createElement("tr", {
        className: classnames('SimpleDataRow ', _define_property({
            isCollapsed: data.isCollapsed,
            isFocused: data.focused
        }, data.category_name, data.category_name)),
        style: {
            backgroundColor: ((_state_hoveredData = state.hoveredData) === null || _state_hoveredData === void 0 ? void 0 : _state_hoveredData.selected) && ((_state_hoveredData1 = state.hoveredData) === null || _state_hoveredData1 === void 0 ? void 0 : _state_hoveredData1.id) === data.id ? "".concat(selectedColour, "44") : '#FFFFFF'
        },
        onMouseEnter: function(e) {
            if (e.target.id !== 'ViewCell' && data.visible) {
                actions.setHoveredData({
                    id: data.id,
                    selected: true
                });
            }
        },
        onMouseLeave: function() {
            if (data.visible) {
                actions.setHoveredData(null);
            }
        },
        onClick: handleClick,
        ref: ref
    }, /*#__PURE__*/ React.createElement(Cell, _object_spread_props(_object_spread({}, isNameFocused && {
        colSpan: 6
    }), {
        className: classnames(COLUMN.POINT_CLOUD, {
            expanded: isNameFocused
        }),
        validationSchema: selectionNameSchema,
        isSuccessful: isSuccess,
        value: dataName,
        disabled: isQuotingJob,
        onSubmit: function(name) {
            actions.setSelections(state.selections.map(function(selection) {
                return _object_spread_props(_object_spread({}, selection), {
                    name: data.id === selection.id ? name : selection.name
                });
            }));
        },
        onFocus: function() {
            setIsNameFocused(true);
        },
        onBlur: function() {
            return setIsNameFocused(false);
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: "product-light",
        style: {
            borderRadius: '50%',
            backgroundColor: selectedColour
        }
    })), !isNameFocused && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("td", {
        className: classnames(COLUMN.AREA, 'text-left pl-3'),
        colSpan: 3
    }, shapeArea), /*#__PURE__*/ React.createElement("td", {
        className: COLUMN.VISIBILITY,
        align: "right"
    }, /*#__PURE__*/ React.createElement(OverlayTrigger, {
        trigger: [
            'hover',
            'focus'
        ],
        placement: "top",
        delay: {
            show: 500,
            hide: 0
        },
        overlay: /*#__PURE__*/ React.createElement(Tooltip, null, text(data.visible ? 'hideShape' : 'showShape'))
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "light btn-eye click-outside-excluded",
        onClick: function(ev) {
            ev.stopPropagation();
            actions.toggleSelectionVisibility(data.id);
        }
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: data.visible ? 'eye' : 'eye-slash'
    })))), /*#__PURE__*/ React.createElement("td", {
        className: COLUMN.MEATBALL,
        align: "right"
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "light btn-more click-outside-excluded",
        onClick: function(ev) {
            ev.stopPropagation();
            if (shapeMenuIsOpened && data.id === state.openedShapeMenu.data.id) {
                actions.closeShapeMenuModal();
                return;
            }
            handleSetOpenedShapeMenu(data, index);
        }
    }, /*#__PURE__*/ React.createElement(Icon, {
        style: {
            pointerEvents: 'none'
        },
        icon: "more"
    })))));
});
SimpleDataRow.propTypes = {
    data: PropTypes.object.isRequired,
    coverage: PropTypes.object,
    index: PropTypes.number.isRequired,
    useMeatballDropdown: PropTypes.bool,
    showClearWhenShapeSelected: PropTypes.bool,
    handleSetOpenedShapeMenu: PropTypes.func
};
SimpleDataRow.defaultProps = {
    useMeatballDropdown: true
};
SimpleDataRow.displayName = 'SimpleDataRow';
export default SimpleDataRow;
